// Cor fixa por caixa de entrada. Com varias caixas na mesma lista, o anel do
// avatar e o ponto do cartao dizem de qual caixa e a conversa, e a lista de
// canais do menu lateral usa a mesma cor (serve de legenda).
const INBOX_COLORS = [
  '#22C55E',
  '#3B82F6',
  '#F59E0B',
  '#EC4899',
  '#8B5CF6',
  '#14B8A6',
  '#F97316',
  '#EF4444',
  '#84CC16',
  '#06B6D4',
];

export const getInboxColor = inbox =>
  INBOX_COLORS[Math.abs(Number(inbox?.id) || 0) % INBOX_COLORS.length];
